// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"sidebar__CYHRh","toggle":"toggle__37IYa","title":"title__1uly_","arrow":"arrow__1rW0c","collapsed":"collapsed__1shTz","menu":"menu__VRZ59","menu-item":"menu-item__Zl3rx","active":"active__2iDJt","beta":"beta__QY7tG","menu-icon":"menu-icon__1gtSj","menu-text":"menu-text__zU-eY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBar/styles.scss
// module id = 2152
// module chunks = 1